import React from 'react';
import './blockStyle.css';
import { FirmwareType, UpdateStatus } from '../types';

interface FirmwareUpdateBlockProps {
  type: FirmwareType;
  currentVersion?: string;
  firmwares: Array<{ id: number; version: string }>;
  selectedId: number | null;
  onIdChange: (id: number) => void;
  file: File | undefined;
  uploading: boolean;
  onFileChange: (file: File) => void;
  onUpload: () => void;
  onStartUpdate: () => void;
  disabledUpdate: boolean;
  isUpdating: boolean;
  updateStatus?: UpdateStatus;
}

const FirmwareUpdateBlock: React.FC<FirmwareUpdateBlockProps> = ({
  type,
  currentVersion = '',
  firmwares,
  selectedId,
  onIdChange,
  file,
  uploading,
  onFileChange,
  onUpload,
  onStartUpdate,
  disabledUpdate,
  isUpdating,
  updateStatus
}) => {
  return (
    <div className="FW-update-block">
      <h3>{type} Firmware</h3>
      <div className="FW-field-row">
        {type !== 'AC_control'
          ? <div className="FW-field">
            <label>текущая версия</label>
            <input value={currentVersion} readOnly />
          </div>
          : null}

        <div className="FW-field">
          <label>версии</label>
          <select
            value={selectedId || ''}
            onChange={(e) => {
              const id = Number(e.target.value);
              if (!isNaN(id)) onIdChange(id);
            }}
          >
            <option value="">выбрать</option>
            {firmwares.map((fw) => (
              <option key={fw.id} value={fw.id}>
                {fw.version}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="FW-flex">
        <label
          className="FW-upload-button"
          data-content={file ? file.name : 'Файл не выбран'}
        >
          Выбрать прошивку -
          <input
            type="file"
            accept=".bin"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) onFileChange(file);
            }}
          />
        </label>

        <button onClick={onUpload} disabled={!file || uploading}>
          {uploading ? 'Загрузка...' : 'Загрузить'}
        </button>
        <button
          onClick={onStartUpdate}
          // disabled={disabledUpdate || isUpdating}
          className="FW-update-button"
        >
          {isUpdating ? 'Обновление...' : 'Обновить'}
        </button>
      </div>
    </div>
  );
};

export default FirmwareUpdateBlock;
